import { matchPath } from "react-router";

import { AIR_ORIGIN_PATH_PATTERN, CONNECT_APP_ROUTE_PATHS } from "../components/constants";

export type AirOriginPath =
  | CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING
  | `${CONNECT_APP_ROUTE_PATHS.IN_REVIEW}/${CONNECT_APP_ROUTE_PATHS.ADDITIONAL_INFORMATION_REQUEST}`;

export const getAirOriginPath = (pathname: string): AirOriginPath | undefined => {
  const match = matchPath({ path: AIR_ORIGIN_PATH_PATTERN }, pathname);
  return match?.params.airOrigin as AirOriginPath | undefined;
};
